import { render } from "./sys-param.vue?vue&type=template&id=39c9ea21&scoped=true"
import script from "./sys-param.vue?vue&type=script&lang=js"
export * from "./sys-param.vue?vue&type=script&lang=js"

import "./sys-param.vue?vue&type=style&index=0&id=39c9ea21&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c9ea21"]])

export default __exports__